import React, { Component } from 'react';
import styled from 'styled-components';
import Navbar from '../../views/shared/navbar/Navbar';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import Banner from './Banner';
import Footer from './Footer';
import * as FormManager from '../../reducers/ui/form';
import { gotoPage } from '../../utils/gotoPage';
import { Routing } from '../../core/Routing';

const PageWrapper = styled.div`
	width: 100%;
	height: 100vh;
`;

type State = {};

class FormSuccessPageComponent extends Component<PropsFromRedux, State> {
	state = {};

	componentDidMount(): void {
		if (!this.props.formSuccess) {
			gotoPage(Routing.main.start);
		}
	}

	componentWillUnmount(): void {
		this.props.setFormSuccess(false);
	}

	render() {
		return (
			<PageWrapper>
				<Navbar variant="blue" />
				<Banner />
				<Footer />
			</PageWrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		formSuccess: FormManager.Selectors.getFormSuccess(state),
	}),
	(dispatch) => ({
		setFormSuccess: (success: boolean) =>
			dispatch(FormManager.Actions.setFormSuccess(success)),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const FormSuccessPage = connector(FormSuccessPageComponent);
export default FormSuccessPage;
